import { GitMerge } from "lucide-react";
import { Link } from "react-router";
import { issueKey } from "../../lib/tasks";
import type { FactoryState } from "../../types";
import { MergeActions } from "../merge-ticket";
import { EmptyState } from "../page";
import { StatusBadge } from "../status-badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";

export function MergeQueueCard({ state }: { state: FactoryState }) {
  const items = state.mergeQueue
    .filter((m) => !["merged", "cancelled", "failed"].includes(m.status))
    .sort((a, b) => a.position - b.position);
  const tasks = new Map(state.tasks.map((t) => [t.id, t]));
  return (
    <Card>
      <CardHeader>
        <CardTitle>Merge queue</CardTitle>
        <CardDescription>
          {items.length
            ? `${items.length} pull request${items.length === 1 ? "" : "s"} lined up`
            : "Nothing waiting to merge"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <EmptyState icon={GitMerge} title="Queue is empty" className="py-6" />
        ) : (
          <ul className="divide-y">
            {items.map((item) => {
              const task = tasks.get(item.taskId);
              return (
                <li key={item.id} className="flex items-center gap-2 py-1">
                  <Link
                    to={`/tasks/${item.taskId}`}
                    className="-mx-2 flex min-w-0 flex-1 items-center gap-3 rounded-md px-2 py-1.5 hover:bg-muted/60"
                  >
                    <span className="flex size-7 shrink-0 items-center justify-center rounded-md bg-muted text-xs font-medium tabular-nums">
                      {item.position}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium">{task?.title ?? `PR #${item.prNumber}`}</p>
                      <p className="truncate text-xs text-muted-foreground">
                        PR #{item.prNumber}
                        {task && issueKey(task) ? ` · ${issueKey(task)}` : ""}
                      </p>
                    </div>
                    <StatusBadge status={item.status} />
                  </Link>
                  <MergeActions item={item} />
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
